import { SActionBtn, SBack, SFormAddOrEditDom, SLowcodeList, STableActions } from 'shj-components'
import { message, Modal, Switch, Tooltip } from 'antd'
import {
  delDealkingTalkOrderHomeConfDtl,
  fetchDealkingTalkOrderHomeConfDtlList,
  getDataDictionaries,
  talkOrderHomeConfDtlBatchDeleteByIds,
} from '@/services/talkOrder.ts'
import { useCallback, useEffect, useRef, useState } from 'react'
import { cloneDeep, get, isArray } from 'lodash-es'
import { useParams } from 'react-router-dom'
import config from './config.ts'
import { AddOrEditAdvertDom } from './addOrEditDom'
import { getFileUrlPrefix } from '@/services/channelManagement.ts'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'

const AdvertisingList = (props: any) => {
  const listRef = useRef<any>()
  const params = useParams()
  const [currentRecord, setCurrentRecord] = useState<any>(null) //新增编辑数据
  const [fileTypeList, setFileTypeList] = useState<any>([])
  const [fileUrl, setFileUrl] = useState('')
  const [configs, setConfigs] = useState<any>(config)
  const [sortState, setSortState] = useState('')
  const sort = useRef<string>('')

  useEffect(() => {
    getFileType()
    getFileUrl()
    const newConfig = cloneDeep(config)
    newConfig.columns.forEach((item: any) => {
      if (item?.dataIndex === 'sortNumber') {
        item.title = (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              justifyContent: 'space-between',
            }}
            onClick={sortNumberClick}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>排序</div>
            <Tooltip
              title={!sortState ? '点击升序' : sortState === 'asc' ? '点击降序' : '取消排序'}
              placement={'top'}
            >
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
                <CaretUpOutlined
                  style={{ fontSize: 12, color: sortState === 'asc' ? '#3D7EFF' : '#BFBFBF' }}
                />
                <CaretDownOutlined
                  style={{ fontSize: 12, color: sortState === 'desc' ? '#3D7EFF' : '#BFBFBF' }}
                />
              </div>
            </Tooltip>
          </div>
        )
      }
    })
    setConfigs(newConfig)
  }, [])

  const sortNumberClick = () => {
    const sortArr = ['', 'asc', 'desc']
    const index = sortArr.indexOf(sort.current)
    if (index === 2) {
      sort.current = ''
    } else {
      sort.current = sortArr[index + 1]
    }
    listRef.current.reset()
  }

  const getFileUrl = () => {
    getFileUrlPrefix().then((res: any) => {
      setFileUrl(res)
    })
  }

  const fetchList = ({ current, pageSize, query }: any) => {
    query.parentId = params?.id
    if (sort.current) {
      query.orderBys = [
        {
          columnName: 'sortNumber',
          asc: sort.current === 'asc',
        },
      ]
    } else {
      query.orderBys = [
        {
          columnName: 'lastUpdatedTime',
          asc: false,
        },
      ]
    }
    return new Promise((resolve, reject) => {
      try {
        fetchDealkingTalkOrderHomeConfDtlList({ current, pageSize, data: query }).then(
          (res: any) => {
            const records = get(res, 'list')
            const total = get(res, 'count')
            setSortState(sort.current)
            resolve({ records, total })
          }
        )
      } catch (e) {
        sort.current = sortState
        reject({ success: false })
      }
    })
  }

  const getFileType = () => {
    getDataDictionaries({ path: 'com.shj.saas.deal.enums.FileTypeEnum' }).then((res: any) => {
      res = res.filter(item => item.key === 'img')
      setFileTypeList(res)
    })
  }

  const onDel = (record: any) => {
    delDealkingTalkOrderHomeConfDtl(record?.id).then((res: any) => {
      message.success('删除成功')
      listRef.current.reload()
    })
  }
  const onBatchDelete = useCallback(({ selectedRowKeys }) => {
    const keys_ = selectedRowKeys.join(',')
    if (keys_) {
      Modal.confirm({
        title: '删除操作',
        content: '确定删除所勾选的吗？',
        onOk() {
          talkOrderHomeConfDtlBatchDeleteByIds(selectedRowKeys).then(res => {
            listRef.current.reload()
          })
        },
        onCancel() {},
      })
    }
  }, [])

  const onEdit = (record: any) => {
    setCurrentRecord(record)
  }

  const onAdd = useCallback(() => {
    setCurrentRecord({})
  }, [])

  const extension = {
    request: { fetchList },
    events: { onAdd, onBatchDelete },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      operationFn(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn confirm danger title="确定删除?" onClick={() => onDel(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      statusFn(text: boolean) {
        return <Switch checked={text} disabled={true} />
      },
      confDtlRelWlistsRender(text: boolean) {
        let contentText = ''
        if (isArray(text)) {
          text.map(item => {
            contentText += item.companyName + '; '
          })
        }
        return contentText
      },
    },
  }

  return (
    <div>
      <SLowcodeList config={{ ...configs }} ref={listRef} {...extension} />
      <SFormAddOrEditDom
        content={<AddOrEditAdvertDom />}
        open={!!currentRecord}
        record={currentRecord}
        onClose={() => {
          setCurrentRecord(null)
        }}
        fn={() => {
          listRef.current.reload()
          setCurrentRecord(null)
        }}
        pid={params?.id}
        parentName={params?.name}
        fileTypeList={fileTypeList}
        fileUrl={fileUrl}
      />
    </div>
  )
}

export default AdvertisingList
